// Components
import { StepIntegrationInstagramComponent } from './step-integration-instagram.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_INTEGRATION_INSTAGRAM = {
  stepIdentifier: 'mediaUploadFlowStepIntegrationInstagram',
  identifier: 'instagram',
  component: StepIntegrationInstagramComponent,
  name: 'Instagram',
  title: 'Instagram Configuration',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
  subStep: true,
} as MediaUploadFlowStep;
